export default __webpack_public_path__ + "static/media/japanese_dragon.35f0477b.jpg";